import React, { useState, useEffect, useMemo } from "react"
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from "./Componentes/auth";
import Axios from 'axios';
import config from './Componentes/config';
import Swal from 'sweetalert2';
import { registrarLog } from './Componentes/logService';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { FaTrash } from 'react-icons/fa';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';
import * as XLSX from 'xlsx';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

// === Tipos de marca (columna `Inasistencia` de registroasistencia) ===
// Estos valores deben coincidir con los que usa el backend en
// /getDatosTrabajadorLiquidacion, en la sincronización de Buk (mapMotivo) y en
// el dashboard. Si se agrega uno nuevo, hay que clasificarlo en los 3 lugares.
const TIPOS_TRABAJADOS = ['Marca normal', 'Sinc. BUK'];   // día efectivamente trabajado
const TIPO_INASISTENCIA = 'Inasistencia';                 // ausencia real (día descontable)
const TIPO_FERIADO = 'Feriado';                           // feriado legal: NO es inasistencia

// Iconos por tipo de marca, usados en el calendario y la leyenda.
const ICONOS_MARCA = {
    'Marca normal': '✅',
    'Sinc. BUK': '🔄',
    'Inasistencia': '❌',
    'Feriado': '🎉',
    'Vacaciones': '🏖️',
    'Permiso': '📝',
    'Licencia': '🏥',
    'Compensado': '⏰',
    'Otro': '❓',
    'Si': '❌' // legado: registros antiguos guardaban 'Si' como inasistencia
};

// Observaciones predefinidas (labor realizada durante la jornada). Si el
// usuario elige 'Otro' se habilita un campo de texto libre.
const OPCIONES_OBSERVACION = [
    'PRODUCCION',
    'RECEPCION DE ACEITE',
    'DESCARGA ACEITE',
    'ASEO EXTRA',
    'ENSAQUE',
    'ACOPIO',
    'TRASVASIJADO',
    'ENGANCHADOR',
    'EMBARQUE',
    'CORTE DE PASTO',
    'CAMBIO DE TURNO',
    'CONTROL DE PESO'
];



function Asistencia() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard]
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);
    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };
    const [trabajadores, setTrabajadores] = useState([]);
    const [idTrabajadorSeleccionado, setIdTrabajadorSeleccionado] = useState('');
    const [nombreTrabajadorSeleccionado, setNombreTrabajadorSeleccionado] = useState('');
    const [rutTrabajadorSeleccionado, setRutTrabajadorSeleccionado] = useState('');
    const [turnoInfo, setTurnoInfo] = useState(null);        // Turno asignado (desde Buk) del trabajador seleccionado
    const [loadingTurno, setLoadingTurno] = useState(false);
    const [fechasConMarcas, setFechasConMarcas] = useState([]);
    const [marcasPorFecha, setMarcasPorFecha] = useState({}); // Nuevo estado para iconos
    const idEmpresa = cookies.idEmpresa;
    const [reloadTrigger, setReloadTrigger] = useState(0);
    const seleccionTrue = (ID) => {
        setSeleccion(true);
        console.log('ID:' + ID);
        // fetchFiles();
    }
    const [seleccion, setSeleccion] = useState(false);
    const getEmpresaName = (card) => getEmpresaByCodigo(card).nombre;
    // Estados para el componente Trabajadores
    const [empresa, setEmpresa] = useState(getEmpresaName(cookies.selectedCard));
    const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
    const [horaEntrada, setHoraEntrada] = useState('');
    const [horaSalida, setHoraSalida] = useState('');
    const [observacion, setObservacion] = useState('');        // opción del desplegable ('' | valor | 'Otro')
    const [observacionOtro, setObservacionOtro] = useState(''); // texto libre cuando la opción es 'Otro'
    const [tomaColacion, setTomaColacion] = useState('');
    const [asistencias, setAsistencias] = useState([]);
    const [asistenciasFiltradas, setAsistenciasFiltradas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [horaTurno, setHoraTurno] = useState('');
    const [horaEturno, setHoraEturno] = useState('');
    const [busqueda, setBusqueda] = useState('');
    const [tipoTurnoa, setTipoTurnoa] = useState('');
    const [fechaISO, setFechaISO] = useState('');
    const [inasistencia, setInasistencia] = useState('Marca normal');
    const [mesSeleccionado, setMesSeleccionado] = useState(new Date().getMonth() + 1); // 0 = Enero
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear()); // Año actual
    const [sincronizando, setSincronizando] = useState(false); // Estado para loading de sincronización
    const [sincronizandoEmpresa, setSincronizandoEmpresa] = useState(false); // Loading de sync masivo
    const [marcaEditando, setMarcaEditando] = useState(null); // Estado para modal de edición

    const getTrabajadores = () => {
        console.log("idEmpresa:", idEmpresa);  // Verifica que idEmpresa tiene el valor esperado
        console.log("intentando cargar trabajadores compensado");
        Axios.get(`${config.API_URL}/CargaTrabajadores?id=${idEmpresa}`)
            .then(res => {
                console.log(res.data); // Verifica la estructura de la respuesta
                if (Array.isArray(res.data)) {
                    setTrabajadores(res.data); // Asegúrate de que sea un array
                } else {
                    console.error('La respuesta no es un array:', res.data);
                    setTrabajadores([]); // Establece un array vacío si no es un array
                }
            })
            .catch(err => {
                console.error("Error al obtener los datos:", err);
            });
    }


    const marcarDias = ({ date, view }) => {
        if (view === 'month') {
            const fecha = date.toISOString().split('T')[0];
            const marca = marcasPorFecha[fecha];

            if (marca) {
                const icono = ICONOS_MARCA[marca] || '✅';

                return (
                    <div
                        className="marca-icono"
                        style={{
                            position: 'absolute',
                            top: '2px',
                            right: '2px',
                            fontSize: '10px',
                            lineHeight: '1',
                            background: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '50%',
                            width: '16px',
                            height: '16px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1,
                            border: '1px solid rgba(0,0,0,0.1)'
                        }}
                        title={`Tipo: ${marca}`}
                    >
                        {icono}
                    </div>
                );
            }
        }
        return null;
    };

    function calcularHorasYTurno(entradaStr, salidaStr, tomaColacion, fechaMarca) {
        const entrada = new Date(`${fechaMarca}T${entradaStr}:00`);
        let salida = new Date(`${fechaMarca}T${salidaStr}:00`);

        if (isNaN(entrada.getTime()) || isNaN(salida.getTime())) {
            console.error("Fecha inválida:", fechaMarca, entradaStr, salidaStr);
            return {
                tipoTurno: 'N/A',
                horasTrabajadas: 0,
                horaExtra: 0,
            };
        }

        if (salida <= entrada) {
            salida.setDate(salida.getDate() + 1);
        }

        const diaSemana = entrada.getDay();
        const horaEntrada = entrada.getHours();

        let tipoTurno = '';
        let horaFinTurno;
        let horaExtra = 0;

        // === DEFINICIÓN DEL TURNO ===
        if (horaEntrada >= 7 && horaEntrada < 15) {
            tipoTurno = 'Turno día';
            // Turno día
            if (diaSemana >= 1 && diaSemana <= 5) {
                horaFinTurno = new Date(`${fechaMarca}T18:00:00`);
            } else if (diaSemana === 6) {
                horaFinTurno = new Date(`${fechaMarca}T13:00:00`); // Sábado hasta 13:00
            } else {
                horaFinTurno = entrada; // Domingo sin turno
            }
        } else {
            tipoTurno = 'Turno noche';
            // Turno noche
            if (diaSemana === 5) { // Viernes noche
                horaFinTurno = new Date(`${fechaMarca}T05:00:00`);
                horaFinTurno.setDate(horaFinTurno.getDate() + 1);
            } else if (diaSemana === 6) { // Sábado noche
                horaFinTurno = entrada; // No hay turno
            } else if (diaSemana === 0) { // Domingo noche
                horaFinTurno = new Date(`${fechaMarca}T00:00:00`);
                horaFinTurno.setDate(horaFinTurno.getDate() + 1); // Lunes 00:00
            } else { // Lunes a jueves noche
                horaFinTurno = new Date(`${fechaMarca}T06:00:00`);
                horaFinTurno.setDate(horaFinTurno.getDate() + 1);
            }
        }

        // Seguridad: si horaFinTurno es antes que la entrada
        if (horaFinTurno <= entrada) {
            horaFinTurno.setDate(horaFinTurno.getDate() + 1);
        }

        // === CÁLCULO DE HORAS TRABAJADAS ===
        const tiempoTrabajadoMs = salida - entrada;
        let horasTrabajadas = (tiempoTrabajadoMs / 1000 / 60 / 60);

        // === CÁLCULO DE HORAS EXTRA ===
        const extraMs = salida - horaFinTurno;
        if (extraMs > 0) {
            horaExtra = extraMs / 1000 / 60 / 60;
        }

        // === CASO ESPECIAL: domingo noche (20:00 a 06:00) ===
        if (diaSemana === 0 && tipoTurno === 'Turno noche') {
            const finExtra = new Date(`${fechaMarca}T00:00:00`);
            finExtra.setDate(finExtra.getDate() + 1); // Lunes 00:00

            const extraMsDomingo = finExtra - entrada;
            horaExtra = extraMsDomingo / 1000 / 60 / 60;
        }

        // === COLACIÓN ===
        if (tomaColacion === 'si') {
            if (tipoTurno === 'Turno día' && diaSemana >= 1 && diaSemana <= 5) {
                horasTrabajadas -= 1; // Solo se descuenta lunes a viernes
            }
        } else {
            horaExtra += 1; // Se paga como hora extra
            // ✅ No sumar a horasTrabajadas
        }

        if (horasTrabajadas < 0) horasTrabajadas = 0;

        return {
            tipoTurno,
            horasTrabajadas: Number(horasTrabajadas.toFixed(2)),
            horaExtra: Number(horaExtra.toFixed(2)),
        };
    }

    // Función para mostrar modal de marcas incompletas con opción de completar
    const mostrarModalMarcasIncompletas = async (data) => {
        if (!data.marcasIncompletas || data.marcasIncompletas.length === 0) return;

        // Generar HTML con lista de marcas problemáticas
        let htmlMarcas = '<div style="max-height: 400px; overflow-y: auto;">';

        data.marcasIncompletas.forEach((marca, index) => {
            const fechaFormateada = new Date(marca.fecha + 'T00:00:00').toLocaleDateString('es-CL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });

            htmlMarcas += `
                <div style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 15px; margin-bottom: 15px; border-radius: 5px;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div style="flex: 1;">
                            <p style="margin: 0; font-weight: bold; color: #856404;">⚠️ ${fechaFormateada}</p>
                            <p style="margin: 5px 0 0 0; color: #856404;">${marca.problema}</p>
                            <small style="color: #6c757d;">Marcas encontradas:</small>
                            <ul style="margin: 5px 0; padding-left: 20px;">
                                ${(Array.isArray(marca.marcasEncontradas) ? marca.marcasEncontradas : []).map(m =>
                `<li style="color: ${m.tipo === 'Ingreso' ? '#28a745' : '#dc3545'};">${m.hora} - ${m.tipo}</li>`
            ).join('')}
                            </ul>
                        </div>
                        <button 
                            class="btn-completar-marca"
                            data-index="${index}"
                            style="
                                background-color: #007bff;
                                color: white;
                                border: none;
                                padding: 8px 16px;
                                border-radius: 5px;
                                cursor: pointer;
                                font-size: 14px;
                                margin-left: 10px;
                            "
                        >
                            Completar Ahora
                        </button>
                    </div>
                </div>
            `;
        });

        htmlMarcas += '</div>';

        const result = await Swal.fire({
            title: '⚠️ Marcas Incompletas Detectadas',
            html: `
                <div style="text-align: left;">
                    <p style="margin-bottom: 15px;">Se detectaron <strong>${data.marcasIncompletas.length}</strong> día(s) con marcas desbalanceadas:</p>
                    ${htmlMarcas}
                    <div style="background-color: #e7f3ff; padding: 10px; border-radius: 5px; margin-top: 15px;">
                        <small style="color: #004085;">
                            💡 <strong>Tip:</strong> Las marcas se insertaron correctamente pero puede que falte algún registro intermedio (ej: regreso de colación).
                            Haz clic en "Completar Ahora" para revisar y agregar marcas faltantes.
                        </small>
                    </div>
                </div>
            `,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Entendido',
            width: '700px',
            didOpen: () => {
                // Agregar event listeners a los botones de completar
                document.querySelectorAll('.btn-completar-marca').forEach(btn => {
                    btn.addEventListener('click', async (e) => {
                        const index = parseInt(e.target.dataset.index);
                        const marca = data.marcasIncompletas[index];
                        await mostrarModalCompletarMarca(marca);
                    });
                });
            }
        });
    };

    // Función para mostrar modal para completar una marca específica
    const mostrarModalCompletarMarca = async (marcaData) => {
        const fechaFormateada = new Date(marcaData.fecha + 'T00:00:00').toLocaleDateString('es-CL', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });

        const { value: formValues } = await Swal.fire({
            title: `Completar Marcas - ${fechaFormateada}`,
            html: `
                <div style="text-align: left;">
                    <div style="background-color: #f8f9fa; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                        <p style="margin: 0; font-weight: bold;">Marcas encontradas en Buk Asistencia:</p>
                        <ul style="margin: 5px 0; padding-left: 20px;">
                            ${marcaData.marcasEncontradas.map(m =>
                `<li style="color: ${m.tipo === 'Ingreso' ? '#28a745' : '#dc3545'};">${m.hora} - ${m.tipo}</li>`
            ).join('')}
                        </ul>
                        <p style="margin: 10px 0 0 0; color: #856404;"><strong>Problema:</strong> ${marcaData.problema}</p>
                    </div>
                    
                    <div style="margin-top: 15px;">
                        <label style="display: block; margin-bottom: 5px; font-weight: bold;">Agregar marca faltante:</label>
                        
                        <div style="margin-bottom: 10px;">
                            <label>Tipo de marca:</label>
                            <select id="tipoMarca" class="swal2-input" style="width: 100%; max-width: 100%; box-sizing: border-box;">
                                <option value="Ingreso" ${marcaData.cantidadIngresos < marcaData.cantidadSalidas ? 'selected' : ''}>Ingreso</option>
                                <option value="Salida" ${marcaData.cantidadSalidas < marcaData.cantidadIngresos ? 'selected' : ''}>Salida</option>
                            </select>
                        </div>
                        
                        <div style="margin-bottom: 10px;">
                            <label>Hora (HH:MM):</label>
                            <input type="time" id="horaMarca" style="width: 100%; max-width: 100%; padding: 10px; box-sizing: border-box; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px;" required>
                        </div>
                        
                        <div style="margin-bottom: 10px;">
                            <label>Observación (opcional):</label>
                            <textarea id="observacionMarca" class="swal2-input" style="width: 100%; max-width: 100%; min-height: 60px; box-sizing: border-box;" placeholder="Ej: Marca agregada manualmente - olvidó marcar en reloj"></textarea>
                        </div>
                    </div>
                    
                    <div style="background-color: #fff3cd; padding: 10px; border-radius: 5px; margin-top: 15px;">
                        <small style="color: #856404;">
                            ⚠️ <strong>Importante:</strong> Esta marca se agregará solo en tu sistema local, NO se enviará a Buk.
                        </small>
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Guardar Marca',
            cancelButtonText: 'Cancelar',
            width: '600px',
            preConfirm: () => {
                const tipoMarca = document.getElementById('tipoMarca').value;
                const horaMarca = document.getElementById('horaMarca').value;
                const observacionMarca = document.getElementById('observacionMarca').value;

                if (!horaMarca) {
                    Swal.showValidationMessage('Por favor ingresa la hora de la marca');
                    return false;
                }

                return { tipoMarca, horaMarca, observacionMarca };
            }
        });

        if (formValues) {
            try {
                // Construir las marcas actualizadas
                const marcasActuales = [...marcaData.marcasEncontradas];

                // Agregar la nueva marca
                marcasActuales.push({
                    tipo: formValues.tipoMarca,
                    hora: formValues.horaMarca + ':00'
                });

                // Ordenar marcas cronológicamente considerando turnos nocturnos
                marcasActuales.sort((a, b) => {
                    const timeA = a.hora.split(':').map(Number);
                    const timeB = b.hora.split(':').map(Number);

                    let minutosA = timeA[0] * 60 + timeA[1];
                    let minutosB = timeB[0] * 60 + timeB[1];

                    // Detectar si es turno nocturno (hay marcas tarde >=18h y temprano <12h)
                    const hayMarcasTarde = marcasActuales.some(m => {
                        const h = parseInt(m.hora.split(':')[0]);
                        return h >= 18;
                    });
                    const hayMarcasTemprano = marcasActuales.some(m => {
                        const h = parseInt(m.hora.split(':')[0]);
                        return h < 12;
                    });

                    // Si es turno nocturno, las horas tempranas son del día siguiente
                    if (hayMarcasTarde && hayMarcasTemprano) {
                        if (timeA[0] < 12) minutosA += 24 * 60; // Sumar 24 horas
                        if (timeB[0] < 12) minutosB += 24 * 60;
                    }

                    return minutosA - minutosB;
                });

                // Determinar entrada y salida
                const primeraIngreso = marcasActuales.find(m => m.tipo === 'Ingreso');
                const ultimaSalida = [...marcasActuales].reverse().find(m => m.tipo === 'Salida');

                if (!primeraIngreso || !ultimaSalida) {
                    Swal.fire({
                        title: 'Error',
                        text: 'No se puede guardar: debe haber al menos 1 Ingreso y 1 Salida',
                        icon: 'error'
                    });
                    return;
                }

                // Buscar el ID del registro - viene directamente del backend
                const idRegistro = marcaData.idRegistro;

                if (!idRegistro) {
                    Swal.fire({
                        title: 'Error',
                        html: `
                            <p>No se pudo identificar el registro a actualizar.</p>
                            <small>Este registro fue insertado pero no se obtuvo su ID.</small><br>
                            <small><strong>Sugerencia:</strong> Recarga la página y busca el registro manualmente para editarlo.</small>
                        `,
                        icon: 'error'
                    });
                    return;
                }

                console.log('[Completar Marca] Usando ID del backend:', idRegistro);
                console.log('[Completar Marca] Fecha:', marcaData.fecha, 'Trabajador:', idTrabajadorSeleccionado);

                // Actualizar el registro con la marca completa
                const observacionNueva = formValues.observacionMarca ||
                    `Marca ${formValues.tipoMarca} agregada manualmente a las ${formValues.horaMarca} - Completado por ${cookies.usuario}`;

                console.log('[Completar Marca] Actualizando registro ID:', idRegistro);
                console.log('[Completar Marca] Nueva entrada:', primeraIngreso.hora.substring(0, 5));
                console.log('[Completar Marca] Nueva salida:', ultimaSalida.hora.substring(0, 5));

                const response = await fetch(`${config.API_URL}/api/buk/update-marca/${idRegistro}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        entrada: primeraIngreso.hora.substring(0, 5),
                        salida: ultimaSalida.hora.substring(0, 5),
                        observacion: observacionNueva,
                        usuario: cookies.usuario
                    }),
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    await registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'Asistencia',
                        Detalle: `Marca completada - ${fechaFormateada} - ${formValues.tipoMarca} ${formValues.horaMarca}`,
                        Estado: 'Éxito',
                    });

                    Swal.fire({
                        title: '✅ Marca Completada',
                        html: `
                            <p>Se agregó <strong>${formValues.tipoMarca}</strong> a las <strong>${formValues.horaMarca}</strong></p>
                            <p><small>Nueva entrada: ${primeraIngreso.hora.substring(0, 5)}</small></p>
                            <p><small>Nueva salida: ${ultimaSalida.hora.substring(0, 5)}</small></p>
                            <p><small>Horas recalculadas: ${data.registro.horasTrabajadas}h trabajadas, ${data.registro.horasExtras}h extras</small></p>
                        `,
                        icon: 'success',
                        timer: 3000
                    });

                    // Recargar asistencias
                    setReloadTrigger(prev => prev + 1);
                } else {
                    throw new Error(data.error || 'Error al completar marca');
                }
            } catch (error) {
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Error completando marca - ${error.message}`,
                    Estado: 'Error',
                });

                Swal.fire({
                    title: 'Error',
                    text: error.message,
                    icon: 'error'
                });
            }
        }
    };

    const sincronizarConBuk = async () => {
        // Validar que haya trabajador seleccionado
        if (!idTrabajadorSeleccionado) {
            Swal.fire({
                title: 'Trabajador requerido',
                text: 'Por favor, seleccione un trabajador antes de sincronizar',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // Confirmar acción
        const result = await Swal.fire({
            title: '¿Sincronizar con Buk Asistencia?',
            html: `
                Se importarán las marcas de <strong>${nombreTrabajadorSeleccionado}</strong> desde Buk Asistencia.<br><br>
                <small>⚠️ Solo se traerán datos, no se modificará nada en Buk.</small>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, sincronizar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        setSincronizando(true);

        try {
            // Definir rango de fechas (últimos 30 días por defecto)
            const hoy = new Date();
            const hace30Dias = new Date();
            hace30Dias.setDate(hace30Dias.getDate() - 30);

            const response = await fetch(`${config.API_URL}/api/buk/sync-worker/${idTrabajadorSeleccionado}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    startDate: hace30Dias.toISOString().split('T')[0],
                    endDate: hoy.toISOString().split('T')[0],
                    usuario: cookies.usuario
                }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                // Registrar en log
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Sincronización Buk - ${nombreTrabajadorSeleccionado}: ${data.estadisticas.insertadas} marcas insertadas, ${data.estadisticas.duplicados} duplicados`,
                    Estado: 'Éxito',
                });

                // Verificar si hay marcas incompletas o con advertencia
                const tieneIncompletos = data.estadisticas.incompletos && data.estadisticas.incompletos > 0;
                const tieneAdvertencias = data.estadisticas.conAdvertencia && data.estadisticas.conAdvertencia > 0;

                // Si hay marcas con advertencia, mostrar modal especial
                if (tieneAdvertencias) {
                    mostrarModalMarcasIncompletas(data);
                } else {
                    // Mostrar resultado normal
                    let listaIncompletos = '';
                    if (tieneIncompletos && data.diasIncompletos && data.diasIncompletos.length > 0) {
                        listaIncompletos = '<ul style="text-align: left; margin-top: 10px;">';
                        data.diasIncompletos.forEach(dia => {
                            const fechaFormateada = new Date(dia.fecha + 'T00:00:00').toLocaleDateString('es-CL', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            });
                            listaIncompletos += `<li><strong>${fechaFormateada}:</strong> Falta marca de ${dia.falta}</li>`;
                        });
                        listaIncompletos += '</ul>';
                    }

                    Swal.fire({
                        title: tieneIncompletos ? '⚠️ Sincronización con advertencias' : '✅ Sincronización exitosa',
                        html: `
                            <div style="text-align: left;">
                                <p><strong>Trabajador:</strong> ${data.trabajador.nombre}</p>
                                <p><strong>RUT:</strong> ${data.trabajador.rut}</p>
                                <p><strong>Identificador Buk (RUT):</strong> ${data.trabajador.userIdentifier}</p>
                                <hr>
                                <p>✅ <strong>Marcas insertadas:</strong> ${data.estadisticas.insertadas}</p>
                                <p>⚠️ <strong>Duplicados (ya existían):</strong> ${data.estadisticas.duplicados}</p>
                                ${tieneIncompletos ? `
                                    <p style="color: #856404;">⚠️ <strong>Registros incompletos:</strong> ${data.estadisticas.incompletos}</p>
                                    <div style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 5px; padding: 10px; margin-top: 10px;">
                                        <p style="margin: 0; font-weight: bold; color: #856404;">⚠️ Los siguientes días requieren completarse manualmente:</p>
                                        ${listaIncompletos}
                                        <small style="color: #856404;">Por favor, agregue las marcas faltantes directamente en el sistema.</small>
                                    </div>
                                ` : ''}
                                <p><strong>Total procesadas:</strong> ${data.estadisticas.total}</p>
                            </div>
                        `,
                        icon: tieneIncompletos ? 'warning' : 'success',
                        confirmButtonText: 'Aceptar',
                        width: '600px'
                    });
                }

                // Recargar asistencias
                setReloadTrigger(prev => prev + 1);
            } else {
                // Registrar error en log
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Error en sincronización Buk - ${data.error || 'Error desconocido'}`,
                    Estado: 'Error',
                });

                Swal.fire({
                    title: 'Error en sincronización',
                    text: data.error || data.message || 'No se pudo sincronizar con Buk',
                    icon: 'error',
                    confirmButtonText: 'Entendido'
                });
            }
        } catch (error) {
            // Registrar error en log
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Asistencia',
                Detalle: `Error de conexión en sincronización Buk - ${error.message}`,
                Estado: 'Error',
            });

            Swal.fire({
                title: 'Error de conexión',
                text: 'No se pudo conectar con el servidor. Verifique su conexión a internet.',
                icon: 'error',
                confirmButtonText: 'Entendido'
            });
            console.error('Error sincronizando:', error);
        } finally {
            setSincronizando(false);
        }
    };

    const sincronizarEmpresa = async () => {
        const result = await Swal.fire({
            title: '¿Sincronizar toda la empresa?',
            html: `Se importarán las marcas e inasistencias de <strong>todos los trabajadores</strong> del <strong>mes en curso</strong> desde Buk.<br><br><small>⚠️ Puede tardar un poco. Solo se traen datos, no se modifica nada en Buk.</small>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, sincronizar',
            cancelButtonText: 'Cancelar'
        });
        if (!result.isConfirmed) return;

        setSincronizandoEmpresa(true);
        try {
            const response = await fetch(`${config.API_URL}/api/buk/sync-empresa`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ usuario: cookies.usuario })
            });
            const data = await response.json();
            if (response.ok && data.success) {
                const e = data.estadisticas;
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Sync empresa Buk - ${e.insertadas} marcas, ${e.inasistencias} inasistencias, ${e.duplicados} duplicados (${e.trabajadoresConDatos}/${e.trabajadores} trabajadores)`,
                    Estado: 'Éxito',
                });
                await Swal.fire({
                    title: '✅ Sincronización completada',
                    html: `
                        <div style="text-align:left;">
                            <p><strong>Trabajadores con datos:</strong> ${e.trabajadoresConDatos} de ${e.trabajadores}</p>
                            <hr>
                            <p>✅ <strong>Marcas insertadas:</strong> ${e.insertadas}</p>
                            <p>📝 <strong>Inasistencias:</strong> ${e.inasistencias}</p>
                            <p>⚠️ <strong>Duplicados (ya existían):</strong> ${e.duplicados}</p>
                            <p>⏳ <strong>Jornadas sin salida:</strong> ${e.incompletos}</p>
                        </div>`,
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                    width: '560px'
                });
                setReloadTrigger(prev => prev + 1);
            } else {
                throw new Error(data.error || data.details || 'No se pudo sincronizar la empresa');
            }
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Asistencia',
                Detalle: `Error en sync empresa Buk - ${error.message}`,
                Estado: 'Error',
            });
            Swal.fire({ title: 'Error', text: error.message, icon: 'error', confirmButtonText: 'Entendido' });
        } finally {
            setSincronizandoEmpresa(false);
        }
    };

    const registrarMarca = async () => {
        // Validación de campos obligatorios
        if (!idTrabajadorSeleccionado) {
            Swal.fire({
                title: 'Campo requerido',
                text: 'Por favor, seleccione un trabajador',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (!fechaSeleccionada) {
            Swal.fire({
                title: 'Campo requerido',
                text: 'Por favor, seleccione una fecha',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // Solo la marca normal exige entrada/salida: el resto de los tipos
        // (inasistencia, feriado, vacaciones, etc.) son días sin jornada.
        const esMarcaNormal = inasistencia === 'Marca normal';

        // La observación guardada es la opción del desplegable, salvo cuando se
        // eligió 'Otro': ahí manda el texto libre.
        const observacionFinal = observacion === 'Otro' ? observacionOtro.trim() : observacion;

        if (observacion === 'Otro' && !observacionFinal) {
            Swal.fire({
                title: 'Campo requerido',
                text: 'Por favor, escriba la observación',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (esMarcaNormal && !horaEntrada) {
            Swal.fire({
                title: 'Campo requerido',
                text: 'Por favor, ingrese la hora de entrada',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (esMarcaNormal && !horaSalida) {
            Swal.fire({
                title: 'Campo requerido',
                text: 'Por favor, ingrese la hora de salida',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // En los días sin jornada no se envían horas: así no quedan horas
        // "fantasma" del último cálculo automático sumando en el resumen ni en
        // la liquidación.
        const data = {
            idTrabajador: idTrabajadorSeleccionado,
            fechaMarca: fechaSeleccionada.toISOString().split('T')[0], // '2025-06-27'
            horaEntrada: esMarcaNormal ? horaEntrada : '',
            horaSalida: esMarcaNormal ? horaSalida : '',
            horasTrabajadas: esMarcaNormal ? (Number(horaTurno) || 0) : 0,
            horaExtra: esMarcaNormal ? horaEturno : 0,
            TipoTurno: esMarcaNormal ? tipoTurnoa : '',
            TipoMarca: inasistencia,
            observacion: observacionFinal || '',
            Usuario: cookies.usuario,
        };

        try {
            const response = await fetch(`${config.API_URL}/registraMarca`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (response.ok) {
                // Obtener nombre del trabajador
                const trabajadorSeleccionado = trabajadores.find(t => t.ID_Trabajador === idTrabajadorSeleccionado);
                const nombreTrabajador = trabajadorSeleccionado
                    ? `${trabajadorSeleccionado.Nombres} ${trabajadorSeleccionado.Apellidos}`
                    : `ID: ${idTrabajadorSeleccionado}`;

                // Registrar en log
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Marca registrada para ${nombreTrabajador}. Fecha: ${fechaSeleccionada.toISOString().split('T')[0]}. Tipo: ${inasistencia}${inasistencia === 'Marca normal' ? `. Entrada: ${horaEntrada}, Salida: ${horaSalida}` : ''}${observacionFinal ? `. Observación: ${observacionFinal}` : ''}`,
                    Estado: 'Éxito',
                });

                Swal.fire({
                    title: '¡Éxito!',
                    text: 'Marca registrada correctamente',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                });
                // Limpiar campos si quieres
                setHoraEntrada('');
                setHoraSalida('');
                setHoraTurno('');
                setHoraEturno('');
                setTipoTurnoa('');
                setObservacion('');
                setObservacionOtro('');
                setFechaSeleccionada(new Date());
                setReloadTrigger(prev => prev + 1);
            } else {
                // Registrar error en log
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Error al registrar marca - ${result.message || 'Error desconocido'}`,
                    Estado: 'Error',
                });

                Swal.fire({
                    title: 'Error al registrar',
                    text: result.message || 'Error desconocido al registrar la marca',
                    icon: 'error',
                    confirmButtonText: 'Entendido'
                });
            }
        } catch (error) {
            // Registrar error en log
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Asistencia',
                Detalle: `Error de conexión al registrar marca - ${error.message}`,
                Estado: 'Error',
            });

            Swal.fire({
                title: 'Error de conexión',
                text: 'No se pudo conectar con el servidor. Verifique su conexión a internet.',
                icon: 'error',
                confirmButtonText: 'Entendido'
            });
            console.error(error);
        }
    };

    const handleEliminar = async (idRegistro) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción eliminará el registro.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await Axios.delete(`${config.API_URL}/registraMarca/${idRegistro}`);

                    // Buscar información de la marca eliminada
                    const marcaEliminada = asistenciasFiltradas.find(marca => marca.ID_Registro === idRegistro);
                    const detalleEliminado = marcaEliminada
                        ? `Marca eliminada ID: ${idRegistro}. Trabajador: ${marcaEliminada.Nombres || ''} ${marcaEliminada.Apellidos || ''}, Fecha: ${marcaEliminada.Fecha_Marca}`
                        : `Marca eliminada ID: ${idRegistro}`;

                    // Registrar en log
                    await registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'Asistencia',
                        Detalle: detalleEliminado,
                        Estado: 'Éxito',
                    });

                    Swal.fire('Eliminado', 'La marca fue eliminada correctamente.', 'success');

                    // Si estás usando estado para actualizar la tabla:
                    setAsistenciasFiltradas(prev =>
                        prev.filter(marca => marca.ID_Registro !== idRegistro)
                    );
                } catch (error) {
                    // Registrar error en log
                    await registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'Asistencia',
                        Detalle: `Error al eliminar marca ID: ${idRegistro} - ${error.message}`,
                        Estado: 'Error',
                    });

                    console.error('Error al eliminar:', error);
                    Swal.fire('Error', 'No se pudo eliminar la marca.', 'error');
                }
            }
        });
    };


    // Traer el turno asignado (Buk) del trabajador seleccionado
    useEffect(() => {
        if (!idTrabajadorSeleccionado) {
            setTurnoInfo(null);
            return;
        }
        let activo = true;
        setLoadingTurno(true);
        Axios.get(`${config.API_URL}/api/buk/turno-trabajador/${idTrabajadorSeleccionado}`)
            .then(res => { if (activo) setTurnoInfo(res.data); })
            .catch(() => { if (activo) setTurnoInfo(null); })
            .finally(() => { if (activo) setLoadingTurno(false); });
        return () => { activo = false; };
    }, [idTrabajadorSeleccionado]);

    useEffect(() => {
        if (!idTrabajadorSeleccionado) return;

        Axios.get(`${config.API_URL}/getAsistencias/${idTrabajadorSeleccionado}`)
            .then(res => {
                // Recalcular horas para registros que las tienen en 0
                const asistenciasRecalculadas = res.data.map(reg => {
                    // Solo recalcular si tiene Entrada y Salida pero horas en 0
                    if (reg.Entrada && reg.Salida &&
                        (reg.Horas_Trabajadas === 0 || reg.Horas_Trabajadas === null) &&
                        reg.Inasistencia === 'Marca normal') {

                        const fechaMarca = new Date(reg.Fecha_Marca).toISOString().split('T')[0];
                        const resultado = calcularHorasYTurno(
                            reg.Entrada.substring(0, 5), // "08:53:00" -> "08:53"
                            reg.Salida.substring(0, 5),   // "17:51:00" -> "17:51"
                            'si', // Asumimos que toma colación por defecto
                            fechaMarca
                        );

                        return {
                            ...reg,
                            Horas_Trabajadas: resultado.horasTrabajadas,
                            Horas_extras: resultado.horaExtra,
                            Tipo_Turno: resultado.tipoTurno
                        };
                    }
                    return reg;
                });

                setAsistencias(asistenciasRecalculadas);

                // Crear array de fechas como antes
                const fechas = asistenciasRecalculadas.map(reg => {
                    return new Date(reg.Fecha_Marca).toISOString().split('T')[0];
                });
                setFechasConMarcas(fechas);

                // Crear objeto con fecha y tipo de marca para los iconos
                const marcasPorFechaObj = {};
                asistenciasRecalculadas.forEach(reg => {
                    const fecha = new Date(reg.Fecha_Marca).toISOString().split('T')[0];
                    // Priorizar la inasistencia si existe, sino usar el tipo normal
                    marcasPorFechaObj[fecha] = reg.Inasistencia && reg.Inasistencia !== 'Marca normal'
                        ? reg.Inasistencia
                        : 'Marca normal';
                });
                setMarcasPorFecha(marcasPorFechaObj);
            })
            .catch(() => {
                setAsistencias([]);
                setFechasConMarcas([]);
                setMarcasPorFecha({});
            });
    }, [idTrabajadorSeleccionado, reloadTrigger]);

    useEffect(() => {
        if (!busqueda.trim()) {
            setAsistenciasFiltradas(asistencias);
            return;
        }

        const resultado = asistencias.filter((item) => {
            const fecha = new Date(item.Fecha_Marca).toISOString().split('T')[0]; // ej: 2025-06-27
            return fecha.includes(busqueda.trim());
        });

        setAsistenciasFiltradas(resultado);
    }, [busqueda, asistencias]);

    // Calcula Horas trabajadas y Horas extra del formulario manual SEGÚN el turno
    // asignado al trabajador para el día ingresado (desde Buk).
    // HE = tiempo trabajado fuera de la jornada pactada (antes del inicio + después
    // del fin). Si el día NO está en la planificación semanal del turno (ej.
    // domingo/descanso), TODO el tiempo trabajado se cuenta como hora extra.
    const calcularHorasSegunTurno = (entradaStr, salidaStr, colacion, fechaISO) => {
        const parseMin = (t) => { const [h, m] = t.split(':').map(Number); return h * 60 + m; };
        let entrada = parseMin(entradaStr);
        let salida = parseMin(salidaStr);
        if (salida <= entrada) salida += 24 * 60; // cruce de medianoche
        const worked = (salida - entrada) / 60;

        const labelDia = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
        const wd = labelDia[new Date(fechaISO + 'T00:00:00').getDay()];
        const horarioDia = turnoInfo?.horarioSemana?.find(h => h.dia === wd);

        // Día fuera de la planificación => toda la jornada es hora extra
        if (!horarioDia || !horarioDia.horario) {
            return { tipoTurno: 'Fuera de turno', horasTrabajadas: 0, horaExtra: Number(worked.toFixed(2)) };
        }

        const [ini, fin] = horarioDia.horario.split('-');
        let sIni = parseMin(ini), sFin = parseMin(fin);
        if (sFin <= sIni) sFin += 24 * 60; // turno nocturno

        const antes = Math.max(0, sIni - entrada) / 60;
        const despues = Math.max(0, salida - sFin) / 60;
        const horaExtra = antes + despues;

        let horasTrabajadas = worked - horaExtra;
        if (colacion === 'si') horasTrabajadas -= 1; // descuenta 1h de colación
        if (horasTrabajadas < 0) horasTrabajadas = 0;

        const horaIni = Math.floor(sIni / 60) % 24;
        const tipoTurno = (horaIni >= 7 && horaIni < 15) ? 'Turno día' : 'Turno noche';

        return { tipoTurno, horasTrabajadas: Number(horasTrabajadas.toFixed(2)), horaExtra: Number(horaExtra.toFixed(2)) };
    };

    useEffect(() => {
        if (!horaEntrada || !horaSalida) return;
        const fechaISO = fechaSeleccionada.toISOString().split('T')[0];
        const resultado = calcularHorasSegunTurno(horaEntrada, horaSalida, tomaColacion, fechaISO);
        setHoraTurno(resultado.horasTrabajadas);
        setHoraEturno(resultado.horaExtra);
        setTipoTurnoa(resultado.tipoTurno);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [horaEntrada, horaSalida, tomaColacion, fechaSeleccionada, turnoInfo]);

    const formatearFecha = (fechaStr) => {
        const fecha = new Date(fechaStr);
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const anio = fecha.getFullYear();
        return `${dia}/${mes}/${anio}`;
    };

    useEffect(() => {
        const filtradas = asistencias.filter((asistencia) => {
            const fecha = new Date(asistencia.Fecha_Marca);
            const mes = fecha.getMonth() + 1; // 0-indexed
            const año = fecha.getFullYear();

            const cumpleBusqueda =
                busqueda === '' ||
                asistencia.Fecha_Marca.includes(busqueda) ||
                fecha.toLocaleDateString().includes(busqueda);

            return mes === mesSeleccionado && año === anioSeleccionado && cumpleBusqueda;
        });

        setAsistenciasFiltradas(filtradas);
    }, [asistencias, busqueda, mesSeleccionado, anioSeleccionado]);

    // Función para editar una marca de asistencia
    const handleEditarMarca = async (registro) => {
        // La observación guardada puede ser una de las opciones predefinidas o
        // un texto libre antiguo/'Otro': en ese caso se precarga el texto.
        const obsActual = registro.Observacion || '';
        const esOpcionPredefinida = OPCIONES_OBSERVACION.includes(obsActual);
        const obsSeleccionada = esOpcionPredefinida ? obsActual : (obsActual ? 'Otro' : '');
        const obsTextoLibre = esOpcionPredefinida ? '' : obsActual;

        const { value: formValues } = await Swal.fire({
            title: 'Editar Marca de Asistencia',
            html: `
                <div style="text-align: left;">
                    <div style="background-color: #f8f9fa; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                        <p style="margin: 0;"><strong>Fecha:</strong> ${formatearFecha(registro.Fecha_Marca)}</p>
                        <p style="margin: 5px 0 0 0;"><strong>Trabajador:</strong> ${nombreTrabajadorSeleccionado}</p>
                    </div>
                    
                    <div style="margin-bottom: 10px;">
                        <label style="display: block; margin-bottom: 5px; font-weight: bold;">Hora Entrada:</label>
                        <input type="time" id="editEntrada" value="${mostrarHora(registro.Entrada)}" style="width: 100%; max-width: 100%; padding: 10px; box-sizing: border-box; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px;">
                    </div>
                    
                    <div style="margin-bottom: 10px;">
                        <label style="display: block; margin-bottom: 5px; font-weight: bold;">Hora Salida:</label>
                        <input type="time" id="editSalida" value="${mostrarHora(registro.Salida)}" style="width: 100%; max-width: 100%; padding: 10px; box-sizing: border-box; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px;">
                    </div>

                    <div style="margin-bottom: 10px;">
                        <label style="display: block; margin-bottom: 5px; font-weight: bold;">Horas extra:</label>
                        <input type="number" id="editHorasExtras" step="0.01" min="0" value="${registro.Horas_extras ?? 0}" style="width: 100%; max-width: 100%; padding: 10px; box-sizing: border-box; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px;">
                    </div>

                    <div style="margin-bottom: 10px;">
                        <label style="display: block; margin-bottom: 5px; font-weight: bold;">Observación:</label>
                        <select id="editObservacion" class="swal2-input" style="width: 100%; max-width: 100%; box-sizing: border-box;" onchange="document.getElementById('editObservacionOtro').style.display = this.value === 'Otro' ? 'block' : 'none'; if (this.value === 'Otro') document.getElementById('editObservacionOtro').focus();">
                            <option value="" ${obsSeleccionada === '' ? 'selected' : ''}>Sin observación</option>
                            ${OPCIONES_OBSERVACION.map(op => `<option value="${op}" ${obsSeleccionada === op ? 'selected' : ''}>${op}</option>`).join('')}
                            <option value="Otro" ${obsSeleccionada === 'Otro' ? 'selected' : ''}>Otro</option>
                        </select>
                        <input type="text" id="editObservacionOtro" placeholder="Escriba la observación" value="${obsTextoLibre.replace(/"/g, '&quot;')}" style="display: ${obsSeleccionada === 'Otro' ? 'block' : 'none'}; width: 100%; max-width: 100%; margin-top: 8px; padding: 10px; box-sizing: border-box; border: 1px solid #d9d9d9; border-radius: 4px; font-size: 14px;">
                    </div>

                    <div style="background-color: #e7f3ff; padding: 10px; border-radius: 5px; margin-top: 15px;">
                        <small style="color: #004085;">
                            💡 Las horas trabajadas se ajustan según entrada/salida. Si defines las <strong>horas extra</strong> manualmente, se respeta ese valor (Trabajadas = total − extra).
                        </small>
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Guardar Cambios',
            cancelButtonText: 'Cancelar',
            width: '500px',
            preConfirm: () => {
                const entrada = document.getElementById('editEntrada').value;
                const salida = document.getElementById('editSalida').value;
                const observacionOpcion = document.getElementById('editObservacion').value;
                const observacion = observacionOpcion === 'Otro'
                    ? document.getElementById('editObservacionOtro').value.trim()
                    : observacionOpcion;
                const horasExtras = document.getElementById('editHorasExtras').value;

                if (!entrada || !salida) {
                    Swal.showValidationMessage('Entrada y Salida son obligatorios');
                    return false;
                }

                if (observacionOpcion === 'Otro' && !observacion) {
                    Swal.showValidationMessage('Escriba la observación');
                    return false;
                }

                return { entrada, salida, observacion, horasExtras };
            }
        });

        if (formValues) {
            try {
                const response = await fetch(`${config.API_URL}/api/buk/update-marca/${registro.ID_Registro}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        entrada: formValues.entrada,
                        salida: formValues.salida,
                        observacion: formValues.observacion,
                        horasExtras: formValues.horasExtras,
                        usuario: cookies.usuario
                    }),
                });

                const data = await response.json();

                if (response.ok && data.success) {
                    await registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'Asistencia',
                        Detalle: `Marca editada - ID ${registro.ID_Registro} - ${formatearFecha(registro.Fecha_Marca)}`,
                        Estado: 'Éxito',
                    });

                    Swal.fire({
                        title: '✅ Marca Actualizada',
                        text: 'La marca se actualizó correctamente',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // Recargar asistencias
                    setReloadTrigger(prev => prev + 1);
                } else {
                    throw new Error(data.error || 'Error al actualizar marca');
                }
            } catch (error) {
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Asistencia',
                    Detalle: `Error editando marca - ${error.message}`,
                    Estado: 'Error',
                });

                Swal.fire({
                    title: 'Error',
                    text: error.message,
                    icon: 'error'
                });
            }
        }
    };

    // Función para detectar si una marca tiene problemas (para resaltar visualmente)
    const tieneProblemasEnMarcas = (observacion) => {
        if (!observacion) return false;
        // Detectar si tiene marcas desbalanceadas (ej: "1 ingresos, 2 salidas")
        const match = observacion.match(/(\d+)\s+ingresos?,\s+(\d+)\s+salidas?/);
        if (match) {
            const ingresos = parseInt(match[1]);
            const salidas = parseInt(match[2]);
            return ingresos !== salidas;
        }
        return false;
    };

    // Los días sin jornada (inasistencia, feriado, vacaciones…) se graban con
    // horario 00:00:00 porque la columna TIME no acepta vacío; en pantalla se
    // muestran en blanco para que no parezcan una marca a medianoche.
    const mostrarHora = (hora) => (!hora || hora === '00:00:00' || hora === '00:00') ? '' : hora;

    // === Formato HH:MM desde horas decimales (look tipo Buk) ===
    const decimalAHHMM = (dec) => {
        const totalMin = Math.round((Number(dec) || 0) * 60);
        const h = Math.floor(totalMin / 60);
        const m = totalMin % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    };

    const diasSemanaAbbr = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

    // Lunes (00:00 local) de la semana de una fecha, para agrupar por semana
    const lunesDeSemana = (fechaStr) => {
        const d = new Date(fechaStr);
        d.setHours(0, 0, 0, 0);
        const day = d.getDay(); // 0=Dom..6=Sáb
        d.setDate(d.getDate() + (day === 0 ? -6 : 1 - day));
        return d;
    };

    // Agrupar las asistencias filtradas por semana (Lun–Dom) con total semanal
    const semanas = useMemo(() => {
        const grupos = {};
        for (const r of asistenciasFiltradas) {
            const lunes = lunesDeSemana(r.Fecha_Marca);
            const key = `${lunes.getFullYear()}-${String(lunes.getMonth() + 1).padStart(2, '0')}-${String(lunes.getDate()).padStart(2, '0')}`;
            if (!grupos[key]) grupos[key] = { key, rows: [] };
            grupos[key].rows.push(r);
        }
        const arr = Object.values(grupos).sort((a, b) => a.key.localeCompare(b.key));
        arr.forEach(g => {
            g.rows.sort((a, b) => new Date(a.Fecha_Marca) - new Date(b.Fecha_Marca));
            g.totalTrab = g.rows.reduce((s, r) => s + (Number(r.Horas_Trabajadas) || 0), 0);
            g.totalExtra = g.rows.reduce((s, r) => s + (Number(r.Horas_extras) || 0), 0);
            g.totalHNT = g.rows.reduce((s, r) => s + (Number(r.Horas_no_trabajadas) || 0), 0);
            g.rango = `${formatearFecha(g.rows[0].Fecha_Marca)} – ${formatearFecha(g.rows[g.rows.length - 1].Fecha_Marca)}`;
        });
        return arr;
    }, [asistenciasFiltradas]);

    // Resumen del período seleccionado (para los cards superiores).
    // Cada día se cuenta en UNA sola categoría, con el mismo criterio que usa
    // /getDatosTrabajadorLiquidacion: el feriado NO es inasistencia y la
    // inasistencia real es la marcada explícitamente como tal.
    const resumenPeriodo = useMemo(() => {
        let trab = 0, extra = 0, hnt = 0;
        let dias = 0, inas = 0, permisos = 0, vacaciones = 0, licencias = 0, feriados = 0, otros = 0;
        for (const r of asistenciasFiltradas) {
            trab += Number(r.Horas_Trabajadas) || 0;
            extra += Number(r.Horas_extras) || 0;
            hnt += Number(r.Horas_no_trabajadas) || 0;

            const tipo = r.Inasistencia || 'Marca normal';
            if (TIPOS_TRABAJADOS.includes(tipo)) dias++;
            else if (tipo === TIPO_FERIADO) feriados++;
            else if (tipo === 'Vacaciones') vacaciones++;
            else if (tipo === 'Licencia') licencias++;
            else if (tipo === 'Permiso') permisos++;
            else if (tipo === TIPO_INASISTENCIA || tipo === 'Si') inas++;  // 'Si' = dato legado
            else otros++;                                                   // Compensado / Otro
        }
        return { trab, extra, hnt, dias, inas, permisos, vacaciones, licencias, feriados, otros };
    }, [asistenciasFiltradas]);


// (tabla personalizada por semana reemplaza al DataTable)

    // Exporta a Excel los turnos/asistencia del trabajador (período seleccionado),
    // agrupado por semana con total semanal, similar al reporte de Buk.
    const exportarTurnosExcel = () => {
        if (!idTrabajadorSeleccionado) {
            Swal.fire({ icon: 'warning', title: 'Trabajador requerido', text: 'Selecciona un trabajador antes de exportar', confirmButtonText: 'Entendido' });
            return;
        }
        if (semanas.length === 0) {
            Swal.fire({ icon: 'info', title: 'Sin datos', text: 'No hay marcas en el período seleccionado para exportar', confirmButtonText: 'Entendido' });
            return;
        }

        const labelDia = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
        const horarioDelDia = (fechaStr) => {
            const wd = labelDia[new Date(fechaStr).getDay()];
            const h = turnoInfo?.horarioSemana?.find(x => x.dia === wd);
            return h?.horario || '-';
        };
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        const aoa = [];
        aoa.push(['Reporte de turnos y asistencia']);
        aoa.push(['Empresa', empresa]);
        aoa.push(['Trabajador', nombreTrabajadorSeleccionado || '']);
        aoa.push(['RUT', rutTrabajadorSeleccionado || '']);
        aoa.push(['Período', `${meses[mesSeleccionado - 1]} ${anioSeleccionado}`]);
        aoa.push(['Turno asignado', (turnoInfo && turnoInfo.turnoActual && turnoInfo.turnoActual.nombreTurno) || '-']);
        aoa.push([]);

        const encabezado = ['Jor', 'Fecha', 'Turno', 'Entrada', 'Salida', 'Horas Trabajadas', 'Horas Extra', 'Horas No Trabajadas', 'Tipo Marca', 'Observación'];
        let totalTrabP = 0, totalExtraP = 0, totalHntP = 0;

        semanas.forEach(sem => {
            aoa.push([`Semana ${sem.rango}`]);
            aoa.push(encabezado);
            sem.rows.forEach(r => {
                aoa.push([
                    diasSemanaAbbr[new Date(r.Fecha_Marca).getDay()],
                    formatearFecha(r.Fecha_Marca),
                    horarioDelDia(r.Fecha_Marca),
                    mostrarHora(r.Entrada),
                    mostrarHora(r.Salida),
                    decimalAHHMM(r.Horas_Trabajadas),
                    decimalAHHMM(r.Horas_extras),
                    decimalAHHMM(r.Horas_no_trabajadas),
                    r.Inasistencia || '',
                    r.Observacion || ''
                ]);
            });
            aoa.push(['', '', '', '', 'Total semanal', decimalAHHMM(sem.totalTrab), decimalAHHMM(sem.totalExtra), decimalAHHMM(sem.totalHNT), '', '']);
            aoa.push([]);
            totalTrabP += sem.totalTrab;
            totalExtraP += sem.totalExtra;
            totalHntP += sem.totalHNT;
        });

        aoa.push(['', '', '', '', 'TOTAL PERÍODO', decimalAHHMM(totalTrabP), decimalAHHMM(totalExtraP), decimalAHHMM(totalHntP), '', '']);

        const ws = XLSX.utils.aoa_to_sheet(aoa);
        ws['!cols'] = [{ wch: 6 }, { wch: 12 }, { wch: 14 }, { wch: 10 }, { wch: 10 }, { wch: 16 }, { wch: 12 }, { wch: 18 }, { wch: 14 }, { wch: 40 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Turnos');
        const nombreArchivo = `Turnos_${(nombreTrabajadorSeleccionado || 'trabajador').replace(/\s+/g, '_')}_${mesSeleccionado}-${anioSeleccionado}.xlsx`;
        XLSX.writeFile(wb, nombreArchivo);

        registrarLog({
            Usuario: cookies.usuario,
            Modulo: 'Asistencia',
            Detalle: `Exportó turnos a Excel - ${nombreTrabajadorSeleccionado} (${meses[mesSeleccionado - 1]} ${anioSeleccionado})`,
            Estado: 'Éxito',
        });
    };

    useEffect(() => {
        getTrabajadores();
    }, []);

    return (
        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3 d-flex align-items-center justify-content-between flex-wrap">
                                            <h6 className="m-0 font-weight-bold text-primary">
                                                Módulo de Asistencia de {empresa}
                                            </h6>
                                            <div className="d-flex gap-2 flex-wrap">
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => { window.location.href = '/DashboardAsistencia'; }}
                                                    title="Ver dashboard de la empresa"
                                                >
                                                    📊 Dashboard
                                                </button>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={sincronizarEmpresa}
                                                    disabled={sincronizandoEmpresa}
                                                    title="Sincronizar marcas e inasistencias de todos los trabajadores (mes en curso)"
                                                >
                                                    {sincronizandoEmpresa ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                            Sincronizando empresa...
                                                        </>
                                                    ) : (
                                                        '🔄 Sincronizar empresa'
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {/* Layout 2 columnas: Calendario | Formulario */}
                                            <div className="d-flex" style={{ gap: '20px', alignItems: 'stretch', flexWrap: 'wrap' }}>

                                                {/* Columna izquierda: Calendario */}
                                                <div style={{ flex: '0 0 320px', minWidth: '300px' }}>
                                                    <div style={{ background: '#fff', border: '1px solid #e3e6f0', borderLeft: '4px solid #4e73df', borderRadius: '8px', padding: '16px', height: '100%', boxShadow: '0 0.15rem 1.75rem rgba(58,59,69,.05)' }}>
                                                        <div style={{ fontSize: '12px', fontWeight: 700, color: '#4e73df', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '10px' }}>📅 Calendario</div>
                                                        <style jsx>{`
                                                            .react-calendar__tile { position: relative; }
                                                            .marca-icono {
                                                                position: absolute; top: 2px; right: 2px; z-index: 1;
                                                                background: rgba(255, 255, 255, 0.8); border-radius: 50%;
                                                                width: 18px; height: 18px; display: flex;
                                                                align-items: center; justify-content: center; font-size: 10px;
                                                            }
                                                        `}</style>
                                                        <Calendar
                                                            onChange={setFechaSeleccionada}
                                                            value={fechaSeleccionada}
                                                            tileContent={marcarDias}
                                                        />
                                                        <p className="mt-2 mb-1" style={{ fontSize: '13px' }}>
                                                            Fecha: <strong>{fechaSeleccionada.toLocaleDateString()}</strong>
                                                        </p>
                                                        <div className="mt-2" style={{ fontSize: '11px', color: '#858796' }}>
                                                            <div style={{ fontWeight: 700, marginBottom: '2px' }}>Leyenda</div>
                                                            <div>✅ Normal · 🔄 Sinc. BUK · ❌ Inasistencia · 🎉 Feriado</div>
                                                            <div>🏖️ Vacaciones · 📝 Permiso · 🏥 Licencia · ⏰ Compensado · ❓ Otro</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Columna derecha: Formulario */}
                                                <div style={{ flex: '1 1 420px', minWidth: '320px' }}>
                                                    <div style={{ background: '#fff', border: '1px solid #e3e6f0', borderLeft: '4px solid #1cc88a', borderRadius: '8px', padding: '16px', boxShadow: '0 0.15rem 1.75rem rgba(58,59,69,.05)' }}>
                                                        <div style={{ fontSize: '12px', fontWeight: 700, color: '#1cc88a', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '12px' }}>📝 Registrar marca</div>

                                                        {/* Trabajador */}
                                                        <div className="mb-3">
                                                            <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Trabajador</label>
                                                            <select
                                                                className="form-select"
                                                                value={idTrabajadorSeleccionado}
                                                                onChange={(e) => {
                                                                    setIdTrabajadorSeleccionado(e.target.value);
                                                                    seleccionTrue(e.target.value);
                                                                    setNombreTrabajadorSeleccionado(e.target.options[e.target.selectedIndex].text);
                                                                    setRutTrabajadorSeleccionado(e.target.options[e.target.selectedIndex].getAttribute('data-rut'));
                                                                }}
                                                            >
                                                                <option value="">Seleccione un trabajador:</option>
                                                                {trabajadores.map((trabajador) => (
                                                                    <option key={trabajador.ID_Trabajador} value={trabajador.ID_Trabajador} data-rut={trabajador.Rut}>
                                                                        {trabajador.NombreCompleto}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Turno asignado (Buk) */}
                                                        {idTrabajadorSeleccionado && (
                                                            <div className="mb-3 p-2" style={{ border: '1px solid #e3e6f0', borderRadius: '6px', background: '#f8f9fc', fontSize: '13px' }}>
                                                                {loadingTurno ? (
                                                                    <span style={{ color: '#6c757d' }}>Cargando turno…</span>
                                                                ) : turnoInfo && turnoInfo.turnoActual ? (
                                                                    <>
                                                                        <span style={{ fontWeight: 600 }}>🕒 Turno asignado: </span>
                                                                        {turnoInfo.turnoActual.nombreTurno}
                                                                        {turnoInfo.horarioSemana && turnoInfo.horarioSemana.length > 0 ? (
                                                                            <div className="mt-1" style={{ fontSize: '12px' }}>
                                                                                <span className="text-muted">Horario por día: </span>
                                                                                {turnoInfo.horarioSemana.map((h, i) => (
                                                                                    <span key={h.dia}>
                                                                                        <strong>{h.dia}:</strong>{h.horario}{i < turnoInfo.horarioSemana.length - 1 ? ', ' : ''}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        ) : (
                                                                            <span className="text-muted ms-1">(sin horario definido)</span>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <span style={{ color: '#6c757d' }}>Sin turno asignado en Buk (últimos 21 días)</span>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Entrada / Salida / Colación */}
                                                        <div className="row g-2 mb-3">
                                                            <div className="col-sm-4">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Hora entrada</label>
                                                                <input type="time" className="form-control" value={horaEntrada} onChange={(e) => setHoraEntrada(e.target.value)} disabled={inasistencia !== 'Marca normal'} />
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Hora salida</label>
                                                                <input type="time" className="form-control" value={horaSalida} onChange={(e) => setHoraSalida(e.target.value)} disabled={inasistencia !== 'Marca normal'} />
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>¿Toma colación?</label>
                                                                <div className="form-control d-flex align-items-center justify-content-around">
                                                                    <div className="form-check form-check-inline m-0">
                                                                        <input className="form-check-input" type="radio" name="colacion" id="colacionSi" value="si" checked={tomaColacion === 'si'} onChange={() => setTomaColacion('si')} disabled={inasistencia !== 'Marca normal'} />
                                                                        <label className="form-check-label" htmlFor="colacionSi">Sí</label>
                                                                    </div>
                                                                    <div className="form-check form-check-inline m-0">
                                                                        <input className="form-check-input" type="radio" name="colacion" id="colacionNo" value="no" checked={tomaColacion === 'no'} onChange={() => setTomaColacion('no')} disabled={inasistencia !== 'Marca normal'} />
                                                                        <label className="form-check-label" htmlFor="colacionNo">No</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Motivo / Observación */}
                                                        <div className="row g-2 mb-3">
                                                            <div className="col-sm-5">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Motivo</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={inasistencia}
                                                                    onChange={(e) => {
                                                                        const tipo = e.target.value;
                                                                        setInasistencia(tipo);
                                                                        // Los días sin jornada no llevan horario
                                                                        if (tipo !== 'Marca normal') {
                                                                            setHoraEntrada('');
                                                                            setHoraSalida('');
                                                                            setTomaColacion('');
                                                                            setHoraTurno('');
                                                                            setHoraEturno('');
                                                                            setTipoTurnoa('');
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="Marca normal">Marca normal</option>
                                                                    <option value="Inasistencia">Inasistencia</option>
                                                                    <option value="Feriado">Feriado</option>
                                                                    <option value="Vacaciones">Vacaciones</option>
                                                                    <option value="Permiso">Permiso</option>
                                                                    <option value="Licencia">Licencia</option>
                                                                    <option value="Compensado">Compensado</option>
                                                                    <option value="Otro">Otro</option>
                                                                </select>
                                                                {inasistencia !== 'Marca normal' && (
                                                                    <small style={{ color: '#858796', fontSize: '11px' }}>
                                                                        {inasistencia === 'Inasistencia'
                                                                            ? 'Día ausente: se descuenta de los días trabajados en la liquidación.'
                                                                            : inasistencia === 'Feriado'
                                                                                ? 'Feriado legal: día remunerado, no cuenta como inasistencia.'
                                                                                : 'Día sin jornada: no requiere entrada ni salida.'}
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-7">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Observación</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={observacion}
                                                                    onChange={(e) => {
                                                                        setObservacion(e.target.value);
                                                                        if (e.target.value !== 'Otro') setObservacionOtro('');
                                                                    }}
                                                                >
                                                                    <option value="">Sin observación</option>
                                                                    {OPCIONES_OBSERVACION.map(op => (
                                                                        <option key={op} value={op}>{op}</option>
                                                                    ))}
                                                                    <option value="Otro">Otro</option>
                                                                </select>
                                                                {observacion === 'Otro' && (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control mt-2"
                                                                        value={observacionOtro}
                                                                        onChange={(e) => setObservacionOtro(e.target.value)}
                                                                        placeholder="Escriba la observación"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Horas calculadas (automáticas según turno; editables) */}
                                                        <div className="row g-2 mb-3">
                                                            <div className="col-sm-6">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Horas trabajadas</label>
                                                                <input type="text" className="form-control" value={horaTurno} onChange={(e) => setHoraTurno(e.target.value)} disabled={inasistencia !== 'Marca normal'} />
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <label className="form-label mb-1" style={{ fontSize: '13px', fontWeight: 600, color: '#5a5c69' }}>Horas extra</label>
                                                                <input type="text" className="form-control" value={horaEturno} onChange={(e) => setHoraEturno(e.target.value)} disabled={inasistencia !== 'Marca normal'} />
                                                            </div>
                                                        </div>

                                                        {/* Botones */}
                                                        <div className="d-flex gap-2 flex-wrap">
                                                            <button className="btn btn-success flex-fill" onClick={registrarMarca}>
                                                                Registrar marca
                                                            </button>
                                                            <button
                                                                className="btn btn-primary flex-fill"
                                                                onClick={sincronizarConBuk}
                                                                disabled={sincronizando || !idTrabajadorSeleccionado}
                                                                title={!idTrabajadorSeleccionado ? 'Seleccione un trabajador' : 'Sincronizar marcas desde Buk Asistencia'}
                                                            >
                                                                {sincronizando ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        Sincronizando...
                                                                    </>
                                                                ) : (
                                                                    '🔄 Sincronizar Buk'
                                                                )}
                                                            </button>
                                                            <button
                                                                className="btn btn-outline-success"
                                                                onClick={exportarTurnosExcel}
                                                                disabled={!idTrabajadorSeleccionado}
                                                                title={!idTrabajadorSeleccionado ? 'Seleccione un trabajador' : 'Descargar turnos y asistencia a Excel'}
                                                            >
                                                                <i className="fas fa-file-excel"></i> Exportar Excel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card shadow mb-4">
                                                <div class="card-header py-3">
                                                    <h6 class="m-0 font-weight-bold text-primary">Asistencias de {nombreTrabajadorSeleccionado}</h6>
                                                </div>
                                                <div class="card-body">
                                                    <div style={{ padding: '20px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                            <input
                                                                type="text"
                                                                placeholder="Buscar por fecha (ej: 27 o 2025-06)"
                                                                value={busqueda}
                                                                onChange={(e) => setBusqueda(e.target.value)}
                                                                style={{
                                                                    marginBottom: '10px',
                                                                    padding: '8px',
                                                                    width: '250px',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                            <select value={mesSeleccionado} onChange={(e) => setMesSeleccionado(Number(e.target.value))} style={{
                                                                marginBottom: '10px',
                                                                padding: '8px',
                                                                width: '150px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px'
                                                            }} >
                                                                <option value={1}>Enero</option>
                                                                <option value={2}>Febrero</option>
                                                                <option value={3}>Marzo</option>
                                                                <option value={4}>Abril</option>
                                                                <option value={5}>Mayo</option>
                                                                <option value={6}>Junio</option>
                                                                <option value={7}>Julio</option>
                                                                <option value={8}>Agosto</option>
                                                                <option value={9}>Septiembre</option>
                                                                <option value={10}>Octubre</option>
                                                                <option value={11}>Noviembre</option>
                                                                <option value={12}>Diciembre</option>
                                                            </select>
                                                            <select value={anioSeleccionado} onChange={(e) => setAnioSeleccionado(Number(e.target.value))} style={{
                                                                marginBottom: '10px',
                                                                padding: '8px',
                                                                width: '120px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px'
                                                            }} >
                                                                <option value={2024}>2024</option>
                                                                <option value={2025}>2025</option>
                                                                <option value={2026}>2026</option>
                                                                <option value={2027}>2027</option>
                                                            </select>
                                                        </div>
                                                        <div style={{ padding: '20px' }}>
                                                            {/* Cards de resumen del período */}
                                                            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
                                                                {[
                                                                    { label: 'Horas trabajadas', valor: decimalAHHMM(resumenPeriodo.trab), color: '#4e73df', icon: '⏱️' },
                                                                    { label: 'Horas extra', valor: decimalAHHMM(resumenPeriodo.extra), color: '#1cc88a', icon: '👍' },
                                                                    { label: 'Horas no trabajadas', valor: decimalAHHMM(resumenPeriodo.hnt), color: '#fd7e14', icon: '⏳' },
                                                                    { label: 'Días trabajados', valor: resumenPeriodo.dias, color: '#36b9cc', icon: '📅' },
                                                                    { label: 'Inasistencias', valor: resumenPeriodo.inas, color: '#e74a3b', icon: '🚫' },
                                                                    { label: 'Permisos', valor: resumenPeriodo.permisos, color: '#f6c23e', icon: '📝' },
                                                                    { label: 'Feriados', valor: resumenPeriodo.feriados, color: '#6f42c1', icon: '🎉' },
                                                                    { label: 'Vacaciones', valor: resumenPeriodo.vacaciones, color: '#20c9a6', icon: '🏖️' },
                                                                    { label: 'Licencias', valor: resumenPeriodo.licencias, color: '#858796', icon: '🏥' },
                                                                ].map(c => (
                                                                    <div key={c.label} style={{ flex: '1 1 160px', minWidth: '150px', background: '#fff', border: '1px solid #e3e6f0', borderLeft: `4px solid ${c.color}`, borderRadius: '6px', padding: '12px 16px', boxShadow: '0 0.15rem 1.75rem rgba(58,59,69,.05)' }}>
                                                                        <div style={{ fontSize: '11px', fontWeight: 700, color: c.color, textTransform: 'uppercase', letterSpacing: '.5px' }}>{c.icon} {c.label}</div>
                                                                        <div style={{ fontSize: '20px', fontWeight: 700, color: '#5a5c69', marginTop: '4px' }}>{c.valor}</div>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Tabla agrupada por semana con total semanal */}
                                                            {loading ? (
                                                                <div style={{ textAlign: 'center', padding: '20px', color: '#858796' }}>Cargando…</div>
                                                            ) : semanas.length === 0 ? (
                                                                <div style={{ textAlign: 'center', padding: '20px', color: '#858796' }}>No hay marcas registradas</div>
                                                            ) : (
                                                                semanas.map(sem => (
                                                                    <div key={sem.key} style={{ marginBottom: '24px' }}>
                                                                        <div style={{ fontWeight: 600, color: '#4e73df', marginBottom: '6px', fontSize: '14px' }}>
                                                                            Semana {sem.rango}
                                                                        </div>
                                                                        <div style={{ overflowX: 'auto' }}>
                                                                            <table className="table table-sm table-hover" style={{ marginBottom: 0, fontSize: '13px' }}>
                                                                                <thead style={{ background: '#f8f9fc' }}>
                                                                                    <tr>
                                                                                        <th>Jor</th><th>Fecha</th><th>Entrada</th><th>Salida</th>
                                                                                        <th>H. Trabajadas</th><th>H. Extra</th><th>H. No Trab.</th><th>Turno</th><th>Tipo Marca</th><th>Observación</th><th>Acciones</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {sem.rows.map(row => {
                                                                                        const problema = tieneProblemasEnMarcas(row.Observacion);
                                                                                        return (
                                                                                            <tr key={row.ID_Registro} style={problema ? { backgroundColor: '#fff3cd', borderLeft: '4px solid #ffc107' } : {}}>
                                                                                                <td>{diasSemanaAbbr[new Date(row.Fecha_Marca).getDay()]}</td>
                                                                                                <td>{formatearFecha(row.Fecha_Marca)}</td>
                                                                                                <td>{mostrarHora(row.Entrada)}</td>
                                                                                                <td>{mostrarHora(row.Salida)}</td>
                                                                                                <td>{decimalAHHMM(row.Horas_Trabajadas)}</td>
                                                                                                <td style={{ fontWeight: Number(row.Horas_extras) > 0 ? 700 : 400, color: Number(row.Horas_extras) > 0 ? '#1cc88a' : 'inherit' }}>{decimalAHHMM(row.Horas_extras)}</td>
                                                                                                <td style={{ color: Number(row.Horas_no_trabajadas) > 0 ? '#fd7e14' : 'inherit' }}>{decimalAHHMM(row.Horas_no_trabajadas)}</td>
                                                                                                <td>{row.Tipo_Turno}</td>
                                                                                                <td>{row.Inasistencia}</td>
                                                                                                <td style={{ maxWidth: '220px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.Observacion}>{row.Observacion}</td>
                                                                                                <td>
                                                                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                                                                        <button onClick={() => handleEditarMarca(row)} style={{ backgroundColor: '#007bff', border: 'none', cursor: 'pointer', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }} title="Editar registro">✏️</button>
                                                                                                        <button onClick={() => handleEliminar(row.ID_Registro)} style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', color: 'red' }} title="Eliminar registro"><FaTrash /></button>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                    <tr style={{ background: '#eaecf4', fontWeight: 700 }}>
                                                                                        <td colSpan={4} style={{ textAlign: 'right' }}>Total semanal</td>
                                                                                        <td>{decimalAHHMM(sem.totalTrab)}</td>
                                                                                        <td style={{ color: '#1cc88a' }}>{decimalAHHMM(sem.totalExtra)}</td>
                                                                                        <td style={{ color: '#fd7e14' }}>{decimalAHHMM(sem.totalHNT)}</td>
                                                                                        <td colSpan={4}></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>
    )
}

export default Asistencia
